export default {
  landAreaMin: 0,
  landAreaFrom: 0,
  landAreaMax: 0,
  landAreaTo: 0,
  landPriceMin: 0,
  landPriceMax: 0,
  landPriceFrom: 0,
  landPriceTo: 0,
  landWidthMin: 0,
  landWidthFrom: 0,
  landWidthMax: 0,
  landWidthTo: 0,
  stages: [],
  stage: '',
  builder: '',
  lotgroup: ''
}



// WEBPACK FOOTER //
// ./src/model/LandFilter.js